import React, { FC } from 'react';
import { Button, Container, Grid, makeStyles, PropTypes, Theme, Typography, useMediaQuery } from '@material-ui/core';
import Link from 'next/link';
import { SpacingLayout } from 'components/atoms';

interface QuoteSectionProps {
  text: string;
  wrapperImage: string;
  buttons: Array<{ action: string; text: string; variant?: 'text' | 'outlined' | 'contained'; color?: PropTypes.Color }>;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    backgroundImage: ({ wrapperImage }: Partial<QuoteSectionProps>) =>
      `linear-gradient(0deg, rgba(0, 26, 85, 0.5), rgba(0, 26, 85, 0.5)), url(${wrapperImage})`,
    minHeight: 290,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover !important',
    backgroundPosition: 'center top !important',
    backgroundAttachment: 'fixed',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      minHeight: 351,
    },
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(4),
  },
}));

const QuoteSection: FC<QuoteSectionProps> = ({ text, wrapperImage, buttons }) => {
  const classes = useStyles({ wrapperImage });
  const isSmallUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <SpacingLayout className={classes.wrapper}>
      <Container maxWidth={false} fixed>
        <Grid container spacing={4} justify={'center'}>
          <Grid item>
            <Typography
              data-aos="fade-up"
              data-aos-delay="300"
              className={classes.title}
              variant="h1"
              align={'center'}
              component={'h4'}
            >
              {text}
            </Typography>
          </Grid>
        </Grid>
        {!!buttons.length && (
          <Grid container spacing={isSmallUp ? 6 : 4} justify={'center'}>
            {buttons.map(({ action, text, variant = 'contained', color = 'primary' }, index) => (
              <Grid item key={index} data-aos="fade-up" data-aos-delay={(index + 3) * 200}>
                <Link href={action}>
                  <a>
                    <Button color={color} variant={variant}>
                      {text}
                    </Button>
                  </a>
                </Link>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </SpacingLayout>
  );
};

export default QuoteSection;
